import React, { createContext, useState, useContext, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useTranslation } from 'react-i18next';
import { getMyLoginUser, logoutUser } from '../api/userApi';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const { i18n } = useTranslation();

    // Check if the token has expired -> No needs, as when token is expired, it will be refreshed using refresh token.
    // When refresh token is rejected, then call logout directly from api interceptors.

     useEffect(() => {
        const checkAuthState = async () => {
            const token = localStorage.getItem('token');
            if (token) {
                try {
                    const decodedToken = jwtDecode(token);
    
                    // if (decodedToken.exp * 1000 > Date.now()) {
                    if (decodedToken) {
                        const user = await getMyLoginUser();
                        setUser(user);
                        setIsAuthenticated(true);
                    } else {
                        // Token expired, remove it
                        localStorage.removeItem('token');
                        setUser(null);
                        setIsAuthenticated(false);
                    }    
                } catch (error) {
                    console.error('Invalid token', error); // Debug log
                    localStorage.removeItem('token');
                    setUser(null);
                    setIsAuthenticated(false);
                }
            } else {
                setIsAuthenticated(false);
            }
            setLoading(false);
        }

        checkAuthState();
    }, []);
 
    const login = (loginData) => {
        if (!loginData.accessToken || !loginData.user) {
            return;
        }
        localStorage.setItem('token', loginData.accessToken);
        setUser(loginData.user);
        if (loginData.user.preferredLanguage) {
            i18n.changeLanguage(loginData.user.preferredLanguage.split('-')[0]);
        }
        setIsAuthenticated(true);
    };

    const logout = async () => {
        localStorage.removeItem('token');
        setUser(null);
        setIsAuthenticated(false);
        await logoutUser();
        window.location.href = "/login";
        // redirect to /
    };

    const reloadUser = async () => {
        setLoading(true);
        try {
            const user = await getMyLoginUser();
            setUser(user);
            setIsAuthenticated(true);
        } catch (error) {
            localStorage.removeItem('token');
            setUser(null);
            setIsAuthenticated(false);            
        }
        setLoading(false);
    }

    return (
        <AuthContext.Provider value={{ isAuthenticated, user, login, logout, reloadUser, loading }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
